import React from 'react';
import DefaultQuestionnaireModal from '../default-questionnaire-modals/DefaultQuestionnaireModal';
import AttachedJobsList from '../AttachedJobsList';
import './ReactivateQuestionnaireModal.css';
import Spinner from '../../Spinner';

interface ReactivateQuestionnaireModalProps {
  isOpen: boolean;
  questionnaireId: string;
  isReactivating: boolean;
  onDismiss: () => void;
  onClone: () => void;
  onReactivate: () => void;
  // VI-579 follow-up (Bug 3): forwarded to the embedded AttachedJobsList so the questionnaires
  // table can correct its cached count when the modal's fresh fetch disagrees with it.
  onAttachedJobsCountResolved?: (count: number) => void;
}

const ReactivateQuestionnaireModal: React.FC<ReactivateQuestionnaireModalProps> = ({
  isOpen,
  questionnaireId,
  isReactivating,
  onDismiss,
  onClone,
  onReactivate,
  onAttachedJobsCountResolved,
}) => {
  return (
    <DefaultQuestionnaireModal
      isOpen={isOpen}
      title="Reactivate"
      position="top"
      onClose={onDismiss}
      footer={
        <>
          <hr className="reactivate-modal-divider" />
          <div className="dq-modal-footer reactivate-modal-footer">
            <button
              type="button"
              className="dq-btn dq-btn--cancel reactivate-modal-footer__dismiss"
              onClick={onDismiss}
              disabled={isReactivating}
            >
              Dismiss
            </button>
            <div className="reactivate-modal-footer__actions">
              <button
                type="button"
                className="btn btn-outline-primary reactivate-modal-footer__clone"
                onClick={onClone}
                disabled={isReactivating}
              >
                Clone
              </button>
              <button
                type="button"
                className="dq-btn dq-btn--primary"
                onClick={onReactivate}
                disabled={isReactivating}
              >
                {isReactivating ? (
                  <>
                    <Spinner size="sm" color="light" /> <span className="ml-2">Reactivating...</span>
                  </>
                ) : (
                  'Reactivate Questionnaire'
                )}
              </button>
            </div>
          </div>
        </>
      }
    >
      <p className="reactivate-modal-body__copy">
        Would you like to apply reactivation to all linked jobs? Or clone and manually link to jobs?
      </p>
      <div className="reactivate-modal-body__jobs">
        <AttachedJobsList
          questionnaireId={questionnaireId}
          onCountResolved={onAttachedJobsCountResolved}
        />
      </div>
    </DefaultQuestionnaireModal>
  );
};

export default ReactivateQuestionnaireModal;
